/* unplugin-vue-components disabled */import script from "./MatchAnalysisView.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchAnalysisView.vue?vue&type=script&setup=true&lang=js"

import "./MatchAnalysisView.vue?vue&type=style&index=0&id=6ce13956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce13956"]])

export default __exports__